<template>
	<div v-loading="loading" class="expertStyle">
		<div class="expertTop">
			<el-row :gutter="10">
				<el-col :span="8">
					<div class="contentsmlBox cur" @click="experClick('已质控')">
						<div class="top">
							<svg-icon class="titleSvg" icon-class='icon-home-Qualitycontrol'></svg-icon>
							<span class="marl10">累计质控报告数</span>
							<span class="num">{{DashboradList.TotalCount}}</span>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="contentsmlBox cur" @click="experClick('待质控')">
						<div class="top">
							<svg-icon class="titleSvg" icon-class='icon-home-stay'></svg-icon>
							<span class="marl10">待质控报告数量</span>
							<span class="num">{{DashboradList.ToQCCount}}</span>
						</div>
					</div>
				</el-col>
				<el-col :span="8">
					<div class="contentsmlBox cur" @click="experClick('不合格')">
						<div class="top">
							<svg-icon class="titleSvg" icon-class='icon-home-NonconformityReport'></svg-icon>
							<span class="marl10">检出不合格报告数</span>
							<span class="num">{{DashboradList.UnqualifiedReportCount}}</span>
						</div>
					</div>
				</el-col>
			</el-row>
		</div>
		<el-row :gutter="10">
			<el-col :span="8">
				<div class="contentBigBox expertprogress">
					<div class="title fz16 marb25" v-if="DashboradList.UnCompleteTasks !== undefined">
						<svg-icon class="fz18 marr4" icon-class="homePage"></svg-icon>
						工作进度 <span v-if="DashboradList.UnCompleteTasks&&DashboradList.TotalCount>0&&DashboradList.UnCompleteTasks.length>0">(共{{DashboradList.UnCompleteTasks.length}}条)</span>
						<div class="btn">
							<el-button type="primary" @click="goList()" class="isread" size="mini" round>更多</el-button>
						</div>
					</div>
					<div class="progressBox">
						<div v-if="DashboradList.UnCompleteTasks&&DashboradList.UnCompleteTasks.length>0">
							<div class="progressList cur" v-for="(item,index) in DashboradList.UnCompleteTasks" :key="index" @click="experClick(item)">
								<div class="text">{{item.TaskName}}</div>
								<el-row>
									<el-col :span="21" class="progress">
										<div class="completionProgress">
											<el-progress :percentage="(item.CompleteNum/item.SampledNum)*100" :color="customColor" :show-text="false" :stroke-width="12" class="completionPre"></el-progress>
										</div>
									</el-col>
									<el-col :span="3" class="fz14 textr">{{parseInt((item.CompleteNum/item.SampledNum)*100)}}%</el-col>
								</el-row>
							</div>
						</div>
						<div class="completethetask" v-else>
							<svg-icon icon-class='icon-Completethetask'></svg-icon>
							<div class="text">已完成所有任务</div>
						</div>
					</div>
				</div>
			</el-col>
			<el-col :span="16">
				<div class="contentBigBox expertBottom" ref="averageChart" v-loading="chartsLoading">
					<div class="marb25">
						<div class="title fz16">
							<svg-icon class="fz18 marr4" icon-class="icon-average"></svg-icon>
							历史工作量
							<div class="exportChartDate rt">
								<el-form ref="form" class="qcFrom">
									<el-form-item class="dateForm" label="创建时间">
										<el-date-picker class="time sliderDataCls" v-model="DashboradArr.data" type="daterange" @change="search" size="mini" range-separator="~" value-format="yyyy-MM-dd" format="yyyy-MM-dd" start-placeholder="开始时间" end-placeholder="结束时间">
										</el-date-picker>
									</el-form-item>
								</el-form>
							</div>
							<div class="exportTab rt marr20">
								<div class="sliderScreeningR">
									<a href="javascript:;" @click="seachTab(1)" :class="DashboradArr.type==1?'active':''">按批次</a>
									<a href="javascript:;" @click="seachTab(2)" :class="DashboradArr.type==2?'active':''">按月</a>
								</div>
							</div>
						</div>
					</div>
					<div class="averageChart" style="width:100%; height:320px">
						<div id="averageChart" style="width:100%; height:100%"></div>
					</div>
				</div>
			</el-col>
		</el-row>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	import echarts from 'echarts'
	export default {
		data() {
			return {
				customColor: '#248AFD',
				myChart:null
			}
		},
		watch: {
			skinPeeler: {
			  handler(newValue, oldValue) {
				 this.getAverageEcharts();
			  },
			  deep: true
			}
		},
		activated() {
			this.setqcresultsShow(false);
			this.GetDashboradExpert();
		},
		updated() {
			if (this.$route.path == "/home/experts/expertHome") {
				this.getAverageEcharts();
			}
		},
		mounted(){
			if(this.$route.path == "/home/experts/expertHome"){
				//左侧导航收起时右侧图联动
				let _this = this;
			    this.erd.listenTo(document.getElementsByClassName("el-main"), function (element) {
			       if (_this.myChart) {
						let dom = document.getElementById("averageChart");
						if (dom) {
							dom.style.width = _this.$refs.averageChart.offsetWidth-40 + "px";
							_this.myChart.resize();
						}
					}
			    })
		   }
		},
		computed: {
			...Vuex.mapState('doctor', ['chartsLoading','DashboradList', 'DashboradArr','exportsListTitle','samplingTaskGuid']),
			...Vuex.mapState('breadcrumb', ['loading','skinPeeler'])
		},
		methods: {
			...Vuex.mapMutations('doctor', ['setChartsLoading','doctorDoctorStatus','setTabShow','isRole']),
			...Vuex.mapMutations('breadcrumb', ['changenavselected','setTootipType','setqcresultsShow']),
			...Vuex.mapActions('doctor', ['GetDashboradExpert']),
			goList() {
				this.$router.push("/home/experts/pending");
			},
			search() {
				this.setChartsLoading(true);
				this.DashboradArr.enddt = this.DashboradArr.data[1];
				this.DashboradArr.startdt = this.DashboradArr.data[0];
				this.GetDashboradExpert();
			},
			seachTab(type) {
				this.setChartsLoading(true)
				this.DashboradArr.type = type;
				this.GetDashboradExpert();
			},
			experClick(row) {
				this.setTootipType(false);
				this.samplingTaskGuid.isUnqualified = false;
				if(typeof row == "string"){
					this.setTabShow(false);
					this.exportsListTitle.name = row;
					this.exportsListTitle.categoryName = null;
					this.samplingTaskGuid.id = '';
					if(row == '已质控'){
						this.doctorDoctorStatus('50')
					}
					if(row == '待质控'){
						this.doctorDoctorStatus('15,20')
					}
					if(row == '不合格'){
						this.doctorDoctorStatus('50')
						this.samplingTaskGuid.isUnqualified = true;
					}
				}else{
					this.doctorDoctorStatus('15,20')
					this.setTabShow(true);
					this.exportsListTitle.name = row.TaskName;
					this.exportsListTitle.categoryName = row.CatergoryName;
					this.samplingTaskGuid.id = row.SamplingTaskGuid;
				}
				this.isRole('export')
				this.$router.push('/home/experts/expertsTable');
			},
			getAverageEcharts() {
				let dom = document.getElementById("averageChart");
				this.myChart = echarts.init(dom);
				//院内排名
				let MyScoresdata = [];
				let value = [];
				let color = ['#248AFD'];
				if(this.DashboradList.Jobs.length > 0) {
					this.DashboradList.Jobs.forEach(element => {
						MyScoresdata.push({
							value:element.Count,
							text:element.Text
						})
						value.push(element.Desc)
					})
				}
				let app = {};
				let option = null;
				let changeColor = this.skinPeeler.status?'#ffffff':'#333333';
				option = {
					title: {
						text: '例',
						padding: [0, 0, 0, 15],
						textStyle: {
							color: changeColor,
							fontSize: 12,
							fontWeight: 'normal',
						}
					},
					tooltip: {
						trigger: 'axis',
						axisPointer:{
							type:"none"
						},
						formatter: function(params, ticket, callback) {
						    return `${params[0].data.text}`;
						  },
					},
					grid: {
						left: '2%',
						right: '6%',
						bottom: '1%',
						containLabel: true
					},
					xAxis: {
						name: this.DashboradArr.type == 1 ? '批次' : '月',
						nameTextStyle: {
							color: changeColor
						},
						data: value,
						boundaryGap: false,
						axisLine: {
							show: true,
						},
						axisLabel: {
							textStyle: {
								color: changeColor,
							},
						},
						splitLine: {
							show: false
						}
					},
					yAxis: {
						type: 'value',
						splitLine: { //网格线
							lineStyle: {
								type: 'dashed', //设置网格线类型 dotted：虚线   solid:实线
								color: changeColor
							},
							show: false //隐藏或显示
						},
						axisLabel: {
							textStyle: {
								color: changeColor
							}
						}
					},
					series: [{
						type: 'line',
						color: color[0],
						symbolSize: 8,
						symbol: 'circle',
						lineStyle: {
							normal: {
								color: color[0]
							}
						},
						data: MyScoresdata,
						itemStyle: {
							normal: {
								color: color[0],
								borderColor: color[0],
							}
						},
						areaStyle: {
							color: ["rgba(36, 138, 253,0.5)"]
						}
					}]
				};
				this.myChart.clear();
				this.myChart.setOption(option, true);
				
			},
		},
	}
</script>
<style scoped>
	.progressBox .completethetask{
		text-align: center;
		width: 100%;
		height: 50px;
		font-size: 30px;
		position: absolute;
		top: 0;
		bottom: 0;
		margin: auto;
	}
	.progressBox .completethetask .text{
		font-size: 12px;
		color: #A4A4A4;
	}
	.main_content{
		min-height: 520px;
	}
</style>